import flatten from "lodash/flatten"; // Array.flat and Array.flatMap aren't fully supported yet

export const DEFAULT_SELECT_VALUE = '';

export function findOption(options, value, defaultOption = DEFAULT_SELECT_VALUE) {
  return options.find(option => option.value === value) || defaultOption;
}

export function findOptionWhenGrouped(options, value, defaultOption = DEFAULT_SELECT_VALUE) {
  return flatten(options.map(({ options }) => options)).find(option => option.value === value) || defaultOption;
}

export function findLabel(options, value) {
  const option = findOption(options, value);
  if (option) {
    return option.label;
  }
}
